import * as yup from "yup";
import { t } from "i18next";
import { getStringValidationRequired } from "@/shared/yup";

export const getLoginSchema = () =>
  yup
    .object()
    .shape({
      username: getStringValidationRequired().min(8, " "),
      password: getStringValidationRequired().min(8, " "),
    })
    .test("value-length", t("validation.loginLength"), function (value) {
      if (value.username && value.username.length < 8) {
        return this.createError({
          path: "loginData",
          message: t("validation.loginLength"),
        });
      }
      return true;
    });
